import React from "react";
import { Check, Info } from "lucide-react";

export function InfoHint({ text }) {
	return (
		<span className="monitoring__analysis-strategy-info-hint" title={text}>
			<Info size={14} aria-hidden />
		</span>
	);
}

export function SectionLabel({ children }) {
	return (
		<span className="monitoring__analysis-section-label">{children}</span>
	);
}

export function GreenCheckIcon() {
	return (
		<span className="monitoring__analysis-strategy-list-check" aria-hidden>
			<Check size={10} strokeWidth={3} />
		</span>
	);
}

export function ContextCardLink({ onClick, children }) {
	if (!onClick) return null;
	return (
		<div className="monitoring__analysis-strategy-card-foot">
			<button
				type="button"
				onClick={onClick}
				className="monitoring__analysis-strategy-context-link btn btn-link btn-sm p-0"
			>
				{children} &rarr;
			</button>
		</div>
	);
}

export const OPPORTUNITY_RING_CLASS = {
	high: "monitoring__analysis-strategy-score--high",
	medium: "monitoring__analysis-strategy-score--medium",
	low: "monitoring__analysis-strategy-score--low",
};

export const OPPORTUNITY_TRACK_CLASS = {
	high: "monitoring__analysis-strategy-score-track--high",
	medium: "monitoring__analysis-strategy-score-track--medium",
	low: "monitoring__analysis-strategy-score-track--low",
};

export const OPPORTUNITY_BADGE_CLASS = {
	high: "monitoring__analysis-strategy-eligible--high",
	medium: "monitoring__analysis-strategy-eligible--medium",
	low: "monitoring__analysis-strategy-eligible--low",
};

export function ScoreRing({ score, tier }) {
	const radius = 30;
	const circumference = 2 * Math.PI * radius;
	const offset = circumference * (1 - score / 100);
	return (
		<div className="monitoring__analysis-strategy-score-ring">
			<svg viewBox="0 0 72 72" aria-hidden>
				<circle cx="36" cy="36" r={radius} strokeWidth="7" className="monitoring__analysis-strategy-score-bg" />
				<circle
					cx="36"
					cy="36"
					r={radius}
					strokeWidth="7"
					strokeLinecap="round"
					className={`monitoring__analysis-strategy-score-track ${OPPORTUNITY_TRACK_CLASS[tier]}`}
					strokeDasharray={circumference}
					strokeDashoffset={offset}
				/>
			</svg>
			<div className="monitoring__analysis-strategy-score-value">
				<span className={`monitoring__analysis-strategy-score-num ${OPPORTUNITY_RING_CLASS[tier]}`}>
					{score}
				</span>
				<span className="monitoring__analysis-strategy-score-denom">/100</span>
			</div>
		</div>
	);
}
